
import { requestAPI } from '../utils/common'

let text = (data) => {
  return requestAPI('city/price/list', data)
}
let checkStatus = (data) => {
  return requestAPI('/oapi/driver/signup/checkstatus', data)
}
let createVerifycode = (data) => {
  return requestAPI('/oapi/driver/signup/createverifycode', data)
}
let checkVerifycode = (data) => {
  return requestAPI('/oapi/driver/signup/checkverifycode', data)
}
let getCityOpen = (data) => {
  return requestAPI('oapi/driver/signup/cityopen', data)
}
let getSignUpInfo = (data) => {
  return requestAPI('/oapi/driver/signup/info', data)
}
let updateBasic = (data) => {
  return requestAPI('/oapi/driver/signup/updatebasic', data, 'POST')
}
let getExam = (data) => {
  return requestAPI('/oapi/driver/signup/exam', data)
}
let getExamResult = (data) => {
  return requestAPI('/oapi/driver/signup/examcheck', data, 'POST')
}
let uploadPic = (data) => {
  return requestAPI('/oapi/driver/signup/upload', data,'POST')
}
let uploadImgUrl = (data) => {
  return requestAPI('/public/upload/driver-img', data,'POST', {headers:{'Content-Type':'multipart/form-data'}})
}
let wxConfig = (data) => {
  return requestAPI('/oapi/driver/signup/getwechatsignature', data, 'POST')
}
let updateTshirt = (data) => {
  return requestAPI('/oapi/driver/signup/update_tshirt', data, 'POST')
}
let getOpenid = (data) => {
  return requestAPI('/oapi/driver/signup/getopenid', data, 'POST')
}
let roadbookingList = (data) => {
  return requestAPI('/oapi/driver/signup/roadbookinglist', data, 'POST')
}
let driverBooking = (data) => {
  return requestAPI('/oapi/driver/booking/book', data, 'POST')
}
let checkCard = (data) => {
  return requestAPI('/oapi/driver/signup/checkidcard', data)
}
let checkDriverLicense = (data) => {
  return requestAPI('/oapi/driver/signup/checkdriverlicense', data)
}
let uploadExamCheck = (data) => {
  return requestAPI('/oapi/driver/signup/exampass', data, 'POST')
}
let commonOrganization = (data) => {
  return requestAPI('/oapi/common/organization', data, 'POST')
}
//请求协议列表
let agreementCheck = (data) => {
  return requestAPI('/commonapi/driver/public/privacy-agreement/check', data)
}
//同意协议
let agreementAgree = (data) => {
  return requestAPI('/commonapi/driver/public/privacy-agreement/agree', data)
}

export {
  text,
  checkStatus,
  createVerifycode,
  checkVerifycode,
  uploadPic,
  getCityOpen,
  getSignUpInfo,
  updateBasic,
  getExam,
  getExamResult,
  wxConfig,
  updateTshirt,
  getOpenid,
  roadbookingList,
  driverBooking,
  checkCard,
  checkDriverLicense,
  uploadExamCheck,
  uploadImgUrl,
  commonOrganization,
  agreementCheck,
  agreementAgree
}



// WEBPACK FOOTER //
// ./src/utils/actions.js